module.exports = __webpack_public_path__ + "data/eed73d1.usa-albers.geo.json";